// src/api/v3/shipments-api-v3.js
const API_BASE = process.env.REACT_APP_API_BASE ;

async function handleRes(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const json = await res.json();
      msg = json?.errors?.join(', ') || json?.error || json?.message || msg;
    } catch {}
    throw new Error(msg);
  }
  return res.json();
}

const ShipmentsAPI = {
  async list(params = {}) {
    const url = new URL(`${API_BASE}/api/v3/shipments`);
    Object.entries(params).forEach(([k, v]) => {
      if (v != null && v !== '') url.searchParams.set(k, v);
    });
    const res = await fetch(url, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    return handleRes(res);
  },

  async show(id) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    return handleRes(res);
  },

  async create(data) {
    const res = await fetch(`${API_BASE}/api/v3/shipments`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shipment: data }),
    });
    return handleRes(res);
  },

  async update(id, data) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shipment: data }),
    });
    return handleRes(res);
  },

  async updateStatus(id, status) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}/update_status`, {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ status }),
    });
    return handleRes(res);
  },

  // NOW accepts shipment_type and customer_address_id
  async reschedule(id, { scheduled_at, reschedule_reason, shipment_type, customer_address_id }) {
    const payload = { scheduled_at, reschedule_reason };
    if (shipment_type) payload.shipment_type = shipment_type;
    if (customer_address_id) payload.customer_address_id = customer_address_id;

    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}/reschedule`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    return handleRes(res);
  },

  async destroy(id) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      let msg = `HTTP ${res.status}`;
      try {
        const json = await res.json();
        msg = json?.errors?.join(', ') || json?.error || msg;
      } catch {}
      throw new Error(msg);
    }
    return true;
  },

    async markReturnedToStore(id) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}/mark_returned_to_store`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    });
    return handleRes(res);
  },

  async markDoneTreatmentBNK(id) {
    const res = await fetch(`${API_BASE}/api/v3/shipments/${id}/mark_done_treatment_bnk`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    });
    return handleRes(res);
  },

};
export default ShipmentsAPI;
